import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const ItemNotification = (props) => {

    const [state, setState] = useState({
        url: ''
    })

    useEffect(() => {

        let linkUrl;
        let typeNotification = props.data.type
        let idNotification = props.data.item_id

        if (typeNotification == 'webinar') {
            linkUrl = `/myWebinars/detailes/${idNotification}`
        } else if (typeNotification == 'learningContent') {
            linkUrl = `/Education/content/${idNotification}`
        } else if (typeNotification == 'course') {
            linkUrl = `/Education/mycourses/${idNotification}`
        } else if (typeNotification == 'lottery') {
            linkUrl = `/lottery/details/${idNotification}`
        } else if (typeNotification == 'news') {
            linkUrl = `/News/inner-page/${idNotification}`
        } else {
            linkUrl = 0
        }
        setState({
            ...state,
            url: linkUrl
        })

    }, [])

    return (
        <Link to={state.url} className={`item-notification ${state.url == 0 ? 'disabled' : ''}`}>
            <strong>{props.title}</strong>
            <p>{props.decription}</p>
            <span>{props.date}</span>
            {props.read == 1 ? null : <b></b>}
        </Link>
    );
}

export default ItemNotification;